var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-email-template-example"},[_c('iframe',{attrs:{"srcdoc":_vm.parsedContent,"width":"100%","onload":"this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';"}})])}
var staticRenderFns = []

export { render, staticRenderFns }